// 客戶在後台上傳影片時，只會傳入影片清單，所以只針對影片清單的情境做處理
export const getIdFromYoutubeListLink = (url: string) => {
	try {
		const urlObject = new URL(url);
		const { searchParams } = urlObject;
		const playListId = searchParams.get('list') || '';
		return playListId;
	} catch (error) {
		return '';
	}
};

export const getYoutubeLink = (url: string) => {
	const playListId = getIdFromYoutubeListLink(url);
	return `https://www.youtube.com/embed/videoseries?list=${playListId}`;
};
